import Tour from 'reactour'
import { useTourContext } from '../../context/TourContext'
import CloseTutorialModal from '../Grid/components/Modals/CloseTutorialModal'
import { useAuthContext } from 'context'
import TourCardContent from 'components/Grid/components/TourCardContent'
import ReactDOM from 'react-dom'
import { useEffect } from 'react'

const CustomTour = ({ isOpen }) => {
  const {
    currentTourStep,
    steps,
    isCloseModalOpened,
    setIsCloseModalOpened,
    handleNextTourStep,
    handlePrevTourStep,
    focusTour,
    isOpen: globalIsOpen,
    hideNextButton,
    hidePrevButton,
    tourPaused,
  } = useTourContext()

  const tutorialOverlay = document.getElementById('tutorial-overlay')
  useEffect(() => {
    if (tutorialOverlay) {
      if (isOpen) {
        tutorialOverlay.style.display = 'none'
      } else {
        tutorialOverlay.style.display = 'flex'
      }
    }
  }, [isOpen, tutorialOverlay])

  return (
    <>
      {globalIsOpen && !tourPaused && (
        <>
          {' '}
          <Tour
            onRequestClose={() => setIsCloseModalOpened(true)}
            nextStep={handleNextTourStep}
            goToStep={currentTourStep}
            isOpen={isOpen && globalIsOpen}
            showButtons={false}
            showCloseButton={false}
            showNavigation={false}
            maskSpace={0}
            prevStep={handlePrevTourStep}
            disableKeyboardNavigation={true}
            showNumber={false}
            closeWithMask={false}
            CustomHelper={({ current, totalSteps, content }) => (
              <TourCardContent
                hideNextButton={hideNextButton}
                hidePrevButton={hidePrevButton}
                onClose={() => setIsCloseModalOpened(true)}
                content={content}
                currentStep={current}
                totalSteps={totalSteps}
              />
            )}
            highlightedMaskClassName="rounded"
            updateDelay={500}
            update={currentTourStep.toString()}
            maskClassName={isCloseModalOpened || !focusTour ? 'hidden' : ''}
            disableDotsNavigation={true}
            accentColor="white"
            className={`!bg-primary !text-white  ${
              isCloseModalOpened || !focusTour ? '!z-[100]' : '!z-[1000000000]'
            } !rounded`}
            steps={steps}
          />
          <CloseTutorialModal />
        </>
      )}
    </>
  )
}

export default CustomTour
